import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  Inject,
} from '@angular/core';
import { ImageUrlService } from '@nx-ng/services/image-url.service';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
@Component({
  selector: 'nx-ng-basket-item',
  templateUrl: './basket-item.component.html',
  styleUrls: ['./basket-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketItemComponent {
  @Input()
  id = '';

  @Input()
  title = '';

  @Input()
  description = '';

  @Input()
  termDateTo = '';

  @Input()
  termDateFrom = '';

  @Input()
  banner = '';

  @Input()
  price = 0;

  @Input()
  errorText = '';

  @Input() set count(value: number) {
    this.currentCount = value;
  }

  get count(): number {
    return this.currentCount;
  }
  currentCount = 0;

  @Output()
  quantityUpdated: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  infoClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public imageUrlService: ImageUrlService,
    @Inject(I18NEXT_SERVICE) private i18n: ITranslationService
  ) {}

  get buyButtonId() {
    return `${this.id}-buy-button`;
  }

  handleQuantityUpdated(value: number) {
    this.quantityUpdated.emit(value);
  }

  handleInfoClicked() {
    this.infoClicked.emit();
  }

  get translatedSubtitle(): string {
    const translatedText = this.i18n.t(this.description, {
      ns: 'tickets',
      replace: {
        termDateFrom: this.termDateFrom,
        termDateTo: this.termDateTo,
      },
    });

    return translatedText === this.description ? '' : translatedText;
  }
}
